import { render } from "./MainPage.vue?vue&type=template&id=29a71a24&scoped=true"
import script from "@/assets/js/Home/MainPage.js?vue&type=script&lang=js&external"
export * from "@/assets/js/Home/MainPage.js?vue&type=script&lang=js&external"

import "./MainPage.vue?vue&type=style&index=0&id=29a71a24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a71a24"]])

export default __exports__